import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../styles/element-ui.css';

function install(Vue) {
    Vue.use(ElementUI);
}

export default { install };